export default __webpack_public_path__ + "static/alignedGrids-1801101c947af36dd1b469c5cd11f0ac.gif";